// @ts-nocheck
import { Template } from "@/types/canvas"

export const Templates: Template[] = [
  {
    "version": "6.0.0-beta12",
    "id": "APxCmQX_hz",
    "background": "rgba(255,255,255,0)",
    "objects": [
      {
        "rx": 0,
        "ry": 0,
        "id": "WorkSpaceDrawType",
        "name": "rect",
        "color": "#ffffff",
        "padding": 0,
        "fill": "#ffffff",
        "selectable": false,
        "evented": false,
        "fillType": 0,
        "lockMovementX": false,
        "lockMovementY": false,
        "objectCaching": true,
        "transparentCorners": false,
        "hasBorders": true,
        "globalCompositeOperation": "source-over",
        "type": "Rect",
        "version": "6.0.0-beta12",
        "originX": "left",
        "originY": "top",
        "left": 0,
        "top": 0,
        "width": 612,
        "height": 792,
        "stroke": "rgba(255,255,255,1)",
        "strokeWidth": 1,
        "strokeDashArray": null,
        "strokeLineCap": "butt",
        "strokeDashOffset": 0,
        "strokeLineJoin": "miter",
        "strokeUniform": false,
        "strokeMiterLimit": 4,
        "scaleX": 1,
        "scaleY": 1,
        "angle": 0,
        "flipX": false,
        "flipY": false,
        "opacity": 1,
        "shadow": null,
        "visible": true,
        "backgroundColor": "rgba(0,0,0,0)",
        "fillRule": "nonzero",
        "paintFirst": "fill",
        "skewX": 0,
        "skewY": 0,
      },
      {
        "fontSize": 30,
        "fontWeight": "normal",
        "fontFamily": "Arial",
        "fontStyle": "normal",
        "lineHeight": 12,
        "text": "Please upload your pdf file to edit",
        "charSpacing": 3,
        "textAlign": "center",
        "styles": [],
        "pathStartOffset": 0,
        "pathSide": "left",
        "pathAlign": "baseline",
        "underline": false,
        "overline": false,
        "linethrough": false,
        "textBackgroundColor": "",
        "direction": "ltr",
        "id": "M_VAPTvm1m",
        "name": "textbox",
        "editable": true,
        "color": "rgb(0,0,0)",
        "padding": 0,
        "fill": "rgb(0,0,0)",
        "selectable": true,
        "evented": true,
        "fillType": 0,
        "lockMovementX": false,
        "lockMovementY": false,
        "objectCaching": false,
        "transparentCorners": false,
        "hasBorders": true,
        "radius": 66,
        "globalCompositeOperation": "source-over",
        "type": "Textbox",
        "version": "6.0.0-beta12",
        "originX": "left",
        "originY": "top",
        "left": 18.2276,
        "top": 151.0343,
        "width": 580,
        "height": 362.0857,
        "stroke": null,
        "strokeWidth": 1,
        "strokeDashArray": null,
        "strokeLineCap": "butt",
        "strokeDashOffset": 0,
        "strokeLineJoin": "miter",
        "strokeUniform": false,
        "strokeMiterLimit": 4,
        "scaleX": 1,
        "scaleY": 1,
        "angle": 0,
        "flipX": false,
        "flipY": false,
        "opacity": 1,
        "shadow": null,
        "visible": true,
        "backgroundColor": "",
        "fillRule": "nonzero",
        "paintFirst": "fill",
        "skewX": 0,
        "skewY": 0
      },
    ],
    "workSpace": {
      "fillType": 0,
      "left": 0,
      "top": 0,
      "angle": 0,
      "scaleX": 1,
      "scaleY": 1,
      "color": "#ffffff",
      "fill": "#ffffff",
      "backgroundColor": "rgba(0,0,0,0)",
    },
    "zoom": 0.8,
    "width": 612,
    "height": 792
  }
]